import Prettylog from "@frog/source/engine/testing/utility/Prettylog.js"
import prettyms from "pretty-ms"
// import present from "present"
import diff from "deep-diff"
import {nanoid} from "nanoid"
// import diff from "deep-object-diff"

function present() {
    return Date.now()
}

// {
//     "type": "test",
//     "slug": "skills/farstrike/push",
//     "description": "Something can happen",
//     "func": function() {},
//     "status": "bad",
//     "duration": 231232,
// }
// {
//     "type": "testgroup",
//     "slug": "skillKeys",
//     "count": 0,
//     "badcount": 0,
//     "tests": [],
// }

function trimErrorDepth(stack = "", string) {
    let calls = stack.split("\n")
    const message = calls.shift()
    calls = calls.slice(0, calls.findIndex((call) => call.includes(string)))
    calls.unshift(message)
    calls = calls.join("\n")
    return calls
}
// function trimErrorType(stack) {
//     return stack.substring(stack.indexOf("Error"))
// }
function replaceErrorHeader(stack, header = "Call Stack") {
    return "Error " + header + "\n" + stack.split("\n").slice(1).join("\n")
}

export default class Testlaunch {
    static perform(tests) {
        if(tests instanceof Array == false) {
            tests = [tests]
        }
        return tests.map((test) => {
            if(test.xslug != undefined) {
                test.slug = test.xslug
                test.status = "skipped"
                test.duration = 0
                return
            }
            const startTime = present()
            try {
                test.func()
                test.status = "good"
            } catch(error) {
                test.status = "bad"
                test.error = error
            }
            const endTime = present()
            test.duration = endTime - startTime
            return test
        })
    }
    static report(test, options = {}) {
        if(test.type == "test") {
            Testlaunch.reportTest(test, options)
        } else if(test.type == "testgroup") {
            Testlaunch.reportTestgroup(test, options)
        }
    }
    static group(tests) {
        const rootTestgroup = {
            "tests": {},
            "type": "testgroup",
            "root": true,
            "count": 0,
            "badcount": 0,
            "goodcount": 0,
            "duration": 0
        }
        tests.forEach((test) => {
            test.type = test.type || "test"
            test.slug = test.slug || nanoid()

            const sections = test.slug.split("/")
            let currentTestgroup = rootTestgroup

            while(currentTestgroup != undefined) {
                currentTestgroup.badcount += (test.status == "bad") ? 1 : 0
                currentTestgroup.goodcount += (test.status == "good") ? 1 : 0
                currentTestgroup.count += 1
                currentTestgroup.duration += test.duration

                if(sections.length > 1) {
                    const section = sections.shift()
                    currentTestgroup.tests[section] = currentTestgroup.tests[section] || {
                        "tests": {},
                        "type": "testgroup",
                        "slug": (currentTestgroup.slug ? currentTestgroup.slug + "/" : "") + section,
                        "count": 0,
                        "badcount": 0,
                        "goodcount": 0,
                        "duration": 0
                    }
                    currentTestgroup = currentTestgroup.tests[section]
                } else {
                    currentTestgroup.tests[test.slug] = test
                    currentTestgroup = undefined
                }
            }
        })
        return rootTestgroup
    }
    static normalizeOptions(options = {}) {
        if(options.hierarchy === undefined) options.hierarchy = true
        if(options.header === undefined) options.header = false
        if(options.footer === undefined) options.footer = false
        if(options.includePassingTests === undefined) options.includePassingTests = true
        if(options.includeFailingTests === undefined) options.includeFailingTests = true
        if(options.includeSkippedTests === undefined) options.includeSkippedTests = true
        if(options.includeErrorMessages === undefined) options.includeErrorMessages = true
        if(options.collapseErrors === undefined) options.collapseErrors = false
    }
    static reportTest(test, options = {}) {
        Testlaunch.normalizeOptions(options)

        if(test.status == "bad"
        && options.includeFailingTests == true) {
            let logger = "group"
            if(options.collapseErrors == true) {
                logger = "groupCollapsed"
            }
            if(options.hierarchy == false
            || options.includeErrorMessages == false) {
                logger = "log"
            }
            console[logger](...Prettylog.style([
                {"text": "🔴"}, // 🟥
                {"text": options.hierarchy === false ? test.slug : test.slug.split("/").pop(), "style": {"font-weight": "bold", "color": "red"}},
                {"text": "-"},
                {"text": test.description},
                {"text": "-"},
                {"text": prettyms(test.duration)},
            ]))
            if(options.includeErrorMessages == false) {
                return
            }
            if(typeof test.error == "string") {
                test.error = {"message": test.error}
            }
            console.log(...Prettylog.style({"text": test.error.message}))
            console.log(" ")

            // console.log("!!", "webpack:///./source/engine/testing/Skills.test.js:30")
            if(test.error.expected != test.error.actual) {
                // console.log("Expected:", test.error.expected)
                // console.log("Actual:", test.error.actual)
                const changes = diff.diff(test.error.expected, test.error.actual)
                changes.forEach((change) => {
                    let path = ""
                    if(change.path != undefined) {
                        path = change.path.reduce((path, pathpart) => {
                            return path + (isNaN(pathpart) ? "." + pathpart : "[" + pathpart + "]")
                        }, "")
                    }
                    let expected = ""
                    let computed = ""
                    if("lhs" in change) {
                        if(typeof change.lhs === "string") {
                            expected = "\"" + change.lhs + "\""
                        } else if(typeof change.lhs === "undefined") {
                            expected = "undefined"
                        } else {
                            // expected = change.lhs
                            expected = JSON.stringify(change.lhs)
                        }
                    }
                    if("rhs" in change) {
                        if(typeof change.rhs === "string") {
                            computed = "\"" + change.rhg + "\""
                        } else if(typeof change.rhs === "undefined") {
                            computed = "undefined"
                        } else {
                            // computed = change.rhs
                            computed = JSON.stringify(change.rhs)
                        }
                    }
                    console.log(...Prettylog.style([
                        {"text": "expected" + path, "style": {"color": "green"}},
                        {"text": "="},
                        {"text": expected, "style": {"background-color": "green"}},
                    ]))
                    console.log(...Prettylog.style([
                        {"text": "computed" + path, "style": {"color": "red"}},
                        {"text": "="},
                        {"text": computed, "style": {"background-color": "red"}},
                    ]))

                    console.log(" ")
                })

                if(typeof window != "undefined") {
                    console.log("expected:", test.error.expected)
                    console.log("computed:", test.error.actual)
                    console.log(" ")
                }
            }

            test.error.stack = trimErrorDepth(test.error.stack, "Function.perform")
            test.error.stack = replaceErrorHeader(test.error.stack)
            console.log(test.error.stack)

            if(test.snapshot != undefined) {
                console.log(" ")
                console.log("Test for yourself at", "http://localhost:8080/dev/tests/" + test.slug)
            }

            if(logger == "group"
            || logger == "groupCollapsed") {
                console.groupEnd()
            } else if(logger == "log") {
                console.log(" ")
                console.log(" ")
                console.log(" ")
            }
            return
        }
        if(test.status == "good"
        && options.includePassingTests == true) {
            console.log(...Prettylog.style([
                {"text": "✅"}, // 🟩
                {"text": options.hierarchy === false ? test.slug : test.slug.split("/").pop(), "style": {"font-weight": "bold"}},
                {"text": "-"},
                {"text": test.description},
                {"text": "-"},
                {"text": prettyms(test.duration)},
            ]))
            return
        }
        if(test.status == "skipped"
        && options.includeSkippedTests == true) {
            console.log(...Prettylog.style([
                {"text": "😶"},
                {"text": options.hierarchy === false ? test.slug : test.slug.split("/").pop(), "style": {"font-weight": "bold"}},
                {"text": "-"},
                {"text": test.description},
                {"text": "-"},
                {"text": "SKIPPED"},
            ]))
        }
    }
    static reportTestgroup(testgroup, options = {}) {
        Testlaunch.normalizeOptions(options)

        if(options.header == true
        && testgroup.root == true) {
            Testlaunch.reportSummary(testgroup, options)
            console.log(" ")
        }

        if(options.hierarchy == true) {
            if(testgroup.badcount > 0) {
                console.group(...Prettylog.style([
                    {"text": "🔴"}, // 🟥
                    testgroup.slug != undefined && {"text": testgroup.slug.split("/").pop(), "style": {"color": "red", "font-weight": "bold"}},
                    testgroup.slug != undefined && {"text": "-"},
                    {"text": testgroup.badcount + " out of " + testgroup.count + " test" + (testgroup.count > 1 ? "s" : "") + " failing"},
                    {"text": "-"},
                    {"text": prettyms(testgroup.duration)},
                ]))
            } else if(testgroup.badcount <= 0) {
                console.groupCollapsed(...Prettylog.style([
                    {"text": "✅"}, // 🟩
                    testgroup.slug != undefined && {"text": testgroup.slug.split("/").pop(), "style": {"font-weight": "bold"}},
                    testgroup.slug != undefined && {"text": "-"},
                    {"text": testgroup.count + " test" + (testgroup.count > 1 ? "s" : "")},
                    {"text": "-"},
                    {"text": prettyms(testgroup.duration)},
                ]))
            }
        }
        const tests = Object.values(testgroup.tests).sort((a, b) => {
            if(a.type == "testgroup" && b.type != "testgroup") {
                return -1
            }
            if(a.type != "testgroup" && b.type == "testgroup") {
                return +1
            }
        })
        tests.forEach((test) => {
            if(test.type == "testgroup") {
                Testlaunch.reportTestgroup(test, options)
            } else if(test.type == "test") {
                Testlaunch.reportTest(test, options)
            }
        })
        if(options.hierarchy == true) {
            console.groupEnd()
        }

        if(options.footer == true
        && testgroup.root == true) {
            console.log(" ")
            Testlaunch.reportSummary(testgroup, options)
        }
    }
    static reportSummary(testgroup, options = {}) {
        if(testgroup.badcount > 0) {
            console.log(...Prettylog.style([
                {"text": "🔴"}, // 🟥
                {"text": testgroup.badcount + " out of " + testgroup.count + " test" + (testgroup.count > 1 ? "s" : "") + " failing", "style": {"color": "red"}},
                {"text": "-"},
                {"text": prettyms(testgroup.duration)},
            ]))
        } else if(testgroup.badcount <= 0) {
            console.log(...Prettylog.style([
                {"text": "✅"}, // 🟩
                {"text": testgroup.count + " test" + (testgroup.count > 1 ? "s" : "")},
                {"text": "-"},
                {"text": prettyms(testgroup.duration)},
            ]))
        }
    }
}
